import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ButtonToolbar, Button } from 'reactstrap';
import { reduxForm, Field } from 'redux-form';
import Modal from '../../../shared/components/Modal';
import validate from './Validate';
import SmartHtmlEditor from '../../../shared/components/form/SmartHtmlEditor';
import DateField from '../../../shared/components/form/DateField';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';

const PeriodicAnalysisForm = (props) => {
  const {
    t,
    backHandler,
    handleSubmit,
    change,
    initialize,
    dto,
    studentList,
    analysisItems,
    setAnalysisItems,
    loadAnalysisItems,
  } = props;
  const [modal, setModal] = useState(false);

  function toggleModal() {
    setModal(!modal);
  }

  function onContentChange(values, itemId) {
    const updatedItems = [...analysisItems];
    const itemIndex = updatedItems.findIndex((item) => item.id === itemId);
    if (itemIndex >= 0) {
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        analysisContent: values,
      };
    }
    setAnalysisItems(updatedItems);
  }

  const onSaveClickHandler = async () => {
    await change('sent', true);
    await handleSubmit();
  };

  const isDisabled = () => dto.sent;

  useEffect(() => {
    change('analysisItems', analysisItems);
  }, [analysisItems]);

  useEffect(() => {
    if (dto.id) {
      setAnalysisItems(dto.analysisItems);
    } else {
      loadAnalysisItems();
    }
  }, []);

  useEffect(() => {
    dto.title = t('titles.periodicalAnalysis');
    initialize(dto);
  }, [dto]);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.submit-review-not-changed')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={() => {
          toggleModal();
          onSaveClickHandler(true);
        }}
      />
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.date')}</span>
          <div className="form__form-group-field">
            <Field
              name="date"
              maxDate={new Date()}
              component={DateField}
              disabled={isDisabled()}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.student')}</span>
          <div className="form__form-group-field">
            <Field
              name="relatedObjects"
              component={SelectVirtualized}
              options={studentList}
              isDisabled={dto.id}
              placeholder={t('periodic_analysis.placeholders.student')}
            />
          </div>
        </div>
        {Object.keys(analysisItems).length !== 0 &&
          analysisItems.map((item) => (
            <div key={item.id} className="form__form-group">
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {item.analysisName}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name={item.id}
                    component={SmartHtmlEditor}
                    onEditorChange={(vl) => onContentChange(vl, item.id)}
                    scrollError={false}
                    htmlValue={item.analysisContent}
                    readOnly={isDisabled()}
                  />
                </div>
              </div>
            </div>
          ))}
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          {!dto.sent ? (
            <Button color="warning" onClick={toggleModal}>
              {t('general.send')}
            </Button>
          ) : null}
          <Button
            color="success"
            disabled={isDisabled()}
            onClick={handleSubmit}
          >
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

PeriodicAnalysisForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  setAnalysisItems: PropTypes.func.isRequired,
  loadAnalysisItems: PropTypes.func.isRequired,
  analysisItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  studentList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
};

export default withTranslation('common')(
  reduxForm({
    form: 'PeriodicAnalysisForm',
    validate,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
  })(PeriodicAnalysisForm)
);
